import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import FlipCard from '../components/FlipCard';
import '../components/FlipCard.css';

export default function CardsPage() {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    axios.get('/api/get_cards.php').then(res => setCards(res.data));
  }, []);
  return (
    <Box>
      <Typography variant="h4" mb={3}>Cards</Typography>
      <Box display="flex" flexWrap="wrap" gap={2}>
        {cards.length === 0 ? (
          <Typography color="text.secondary">No cards issued.</Typography>
        ) : (
          cards.map(card => (
            <FlipCard key={card.id} card={card} />
          ))
        )}
      </Box>
    </Box>
  );
}
